import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "./AdherenBirthdate";
import AdherentInfo from "./AdherentInfo";
import AdherentTelecoms from "./AdherentTelecoms";
import BankInformation from "./BankInformation";
import BankInformationWithoutPayment from "./BankInformationWithoutPayment";
import ChildrenJustification from "./ChildrenJustification";
import Loading from "./Components/Loader";
import Default from "./Default";
import EffectiveDate from "./EffectiveDate";
import ElectronicSignature from "./ESign";
import GenerateESignDocuments from "./GenerateESignDocuments";
import GenerateESignDocumentsWithRequiredNotice from "./GenerateESignDocumentsWithRequiredNotice";
import Justification from "./Justification";
import Needs from "./Needs";
import Products from "./Products";
import ProductsPerBeneficiaryWithoutPrice from "./ProductsPerBeneficiaryWithoutPrice";
import ProductsPricePerBeneficiary from "./ProductsPricePerBeneficiary";
import ProductsWithoutPrice from "./ProductsWithoutPrice";
import Profile from "./Profile";
import RelatedPersons from "./RelatedPersons";
import SelectBranch from "./SelectBranch";
import SelectCollectivity from "./SelectCollectivity";
import SocialSecurityNumber from "./SocialSecurityNumber";
import SpouseJustification from "./SpouseJustification";
import SubscriptionDone from "./SubscriptionDone";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].PROFILE]: Profile,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].SELECT_BRANCH]:
    SelectBranch,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].SELECT_COLLECTIVITY]:
    SelectCollectivity,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].ADHERENT_BIRTHDATE]:
    AdherentBirthDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].NEEDS]: Needs,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].ADHERENT_INFO]:
    AdherentInfo,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].PRODUCTS]: Products,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].PRODUCTS_WITHOUT_PRICE]:
    ProductsWithoutPrice,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS]
    .PRODUCTS_PER_BENEFICIARY_WITHOUT_PRICE]:
    ProductsPerBeneficiaryWithoutPrice,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS]
    .PRODUCTS_PRICE_PER_BENEFICIARY]: ProductsPricePerBeneficiary,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].EFFECTIVE_DATE]:
    EffectiveDate,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].ADHERENT_TELECOMS]:
    AdherentTelecoms,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].RELATED_PERSONS]:
    RelatedPersons,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].ADHERENT_BANK_INFORMATION]:
    BankInformation,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS]
    .ADHERENT_BANK_INFORMATION_WITHOUT_PAYMENT]: BankInformationWithoutPayment,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].GENERATE_E_SIGN_DOCUMENTS]:
    GenerateESignDocuments,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS]
    .GENERATE_E_SIGN_DOCUMENTS_WITH_REQUIRED_NOTICE]:
    GenerateESignDocumentsWithRequiredNotice,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].E_SIGN]:
    ElectronicSignature,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].JUSTIFICATIONS]:
    Justification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].SPOUSE_JUSTIFICATIONS]:
    SpouseJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].CHILDREN_JUSTIFICATIONS]:
    ChildrenJustification,
  [TEMPLATES.B2C.THEMES[TEMPLATE_TYPES.B2C_AMELLIS].SUBSCRIPTION_DONE]:
    SubscriptionDone,
  default: Default,
};
export default Templates;
